import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CloudUpload } from '@mui/icons-material';

const UploadBox = styled(Box)(({ theme }) => ({
  border: `2px dashed ${theme.palette.primary.main}`,
  borderRadius: theme.shape.borderRadius,
  padding: theme.spacing(3),
  textAlign: 'center',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: theme.palette.primary.light + '10',
    borderColor: theme.palette.primary.dark,
  },
}));

interface ImageUploadBoxProps {
  title?: string;
  subtitle?: string;
  onClick?: () => void;
  sx?: any;
}

const ImageUploadBox: React.FC<ImageUploadBoxProps> = ({
  title = "Upload Images",
  subtitle = "Click to select images",
  onClick,
  sx = {}
}) => {
  return (
    <UploadBox onClick={onClick} sx={sx}>
      <CloudUpload sx={{ fontSize: 48, color: 'primary.main', mb: 1 }} />
      <Typography variant="h6" gutterBottom>
        {title}
      </Typography>
      <Typography variant="body2" color="text.secondary">
        {subtitle}
      </Typography>
    </UploadBox>
  );
};

export default ImageUploadBox;